import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from './types';

export interface GeneralResponse {
    data: GeneralResponseBody;
}

export interface GeneralResponseBody {
    data: Array<FormType>;
    limit: number;
    message: string;
    page: number;
    totalCount: number;
    totalPages: number;
    warnings: Array<string>;
    count: number;
}
export interface FormType {
    id: string;
    code: string;
    name: string;
}

export interface FormTypePayload {
    policyTypeCode: string;
    claimCategoryCode: string;
}

export const fetchFormTypes = createAction<fetchFormTypesAction>(
    ActionTypes.FETCH_FORM_TYPES,
);
export const fetchFormTypesSuccess = createAction<fetchFormTypesSuccessAction>(
    ActionTypes.FETCH_FORM_TYPES_SUCCESS,
);
export const fetchFormTypesFailed = createAction<fetchFormTypesFailedAction>(
    ActionTypes.FETCH_FORM_TYPES_FAILED,
);
export const fetchFormTypesByPolicyAndCategoryCode =
    createAction<fetchFormTypesByPolicyAndCategoryCodeAction>(
        ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE,
    );
export const fetchFormTypesByPolicyAndCategoryCodeSuccess =
    createAction<fetchFormTypesByPolicyAndCategoryCodeSuccessAction>(
        ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_SUCCESS,
    );
export const fetchFormTypesByPolicyAndCategoryCodeFailed =
    createAction<fetchFormTypesByPolicyAndCategoryCodeFailedAction>(
        ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_FAILED,
    );
export const clearFormTypes = createAction<clearFormTypesAction | undefined>(
    ActionTypes.CLEAR_FORM_TYPES_STATE,
);

export interface fetchFormTypesAction {
    type: typeof ActionTypes.FETCH_FORM_TYPES;
    payload: undefined;
}
export interface fetchFormTypesSuccessAction {
    type: typeof ActionTypes.FETCH_FORM_TYPES_SUCCESS;
    payload: GeneralResponse;
}
export interface fetchFormTypesFailedAction {
    type: typeof ActionTypes.FETCH_FORM_TYPES_FAILED;
    payload: GeneralResponse | any;
}
export interface fetchFormTypesByPolicyAndCategoryCodeAction {
    type: typeof ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE;
    payload: FormTypePayload;
}
export interface fetchFormTypesByPolicyAndCategoryCodeSuccessAction {
    type: typeof ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_SUCCESS;
    body: GeneralResponse;
}
export interface fetchFormTypesByPolicyAndCategoryCodeFailedAction {
    type: typeof ActionTypes.FETCH_FORM_TYPES_BY_POLICY_AND_CATEGORY_CODE_FAILED;
    payload: GeneralResponse | any;
}
export interface clearFormTypesAction {
    type: typeof ActionTypes.CLEAR_FORM_TYPES_STATE;
    payload: undefined;
}
